import React from 'react';

export const ESTADOS = {
  borrador:   { label: 'Borrador',   clase: 'bg-slate-100 text-slate-600 dark:bg-white/10 dark:text-gray-300' },
  programada: { label: 'Programada', clase: 'bg-indigo-50 text-indigo-600 dark:bg-indigo-500/10 dark:text-indigo-300' },
  enviando:   { label: 'Enviando',   clase: 'bg-emerald-50 text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-300', vivo: true },
  pausada:    { label: 'Pausada',    clase: 'bg-amber-50 text-amber-700 dark:bg-amber-500/10 dark:text-amber-300' },
  completada: { label: 'Completada', clase: 'bg-sky-50 text-sky-700 dark:bg-sky-500/10 dark:text-sky-300' },
  cancelada:  { label: 'Cancelada',  clase: 'bg-slate-100 text-slate-400 dark:bg-white/5 dark:text-gray-500' },
};

export const EstadoChip = ({ estado }) => {
  const e = ESTADOS[estado] ?? ESTADOS.borrador;
  return (
    <span className={`inline-flex items-center gap-1.5 text-[11px] font-bold px-2.5 py-1 rounded-full ${e.clase}`}>
      {e.vivo && <span className="size-1.5 rounded-full bg-emerald-500 animate-pulse" aria-hidden="true" />}
      {e.label}
    </span>
  );
};

export const pct = (parte, total) => (total > 0 ? Math.round((parte * 100) / total) : 0);

const Barra = ({ valor, tope, etiqueta, detalle }) => {
  const p = Math.min(100, pct(valor, tope));
  const color = p >= 100 ? 'bg-amber-500' : 'bg-primary';
  return (
    <div className="space-y-1.5">
      <div className="flex justify-between items-baseline gap-2">
        <span className="text-[11px] font-bold text-slate-500 dark:text-gray-400">{etiqueta}</span>
        <span className="text-xs font-bold text-slate-800 dark:text-white tabular-nums">{valor} / {tope}</span>
      </div>
      <div className="h-1.5 rounded-full bg-slate-100 dark:bg-white/10 overflow-hidden">
        <div className={`h-full rounded-full ${color} transition-all`} style={{ width: `${p}%` }} />
      </div>
      {detalle && <p className="text-[10px] text-slate-400 dark:text-gray-500">{detalle}</p>}
    </div>
  );
};

/**
 * Cuánto puede mandar la línea ahora mismo, y por qué. Es la pieza que hace
 * visible la protección: sin esto, una campaña "lenta" parece rota.
 */
export const EstadoDeLinea = ({ linea }) => (
  <div className="bg-white dark:bg-surface-dark rounded-2xl border border-gray-100 dark:border-gray-800 p-5 space-y-4">
    <div className="flex items-start justify-between gap-3">
      <div className="min-w-0">
        <p className="text-sm font-bold text-slate-900 dark:text-white truncate flex items-center gap-1.5">
          <span className="material-symbols-outlined text-[18px] text-emerald-500">phone_iphone</span>
          {linea.linea}
        </p>
        <p className="text-[11px] text-slate-500 dark:text-gray-400 mt-0.5 first-letter:uppercase">{linea.linea_etapa}</p>
      </div>
      <div className="text-right shrink-0">
        <p className="text-2xl font-black text-slate-900 dark:text-white tabular-nums leading-none">{linea.disponible_ahora}</p>
        <p className="text-[10px] font-bold text-slate-400 uppercase tracking-wider mt-1">
          {linea.en_ventana ? 'pueden salir ahora' : 'fuera de horario'}
        </p>
      </div>
    </div>
    <Barra valor={linea.campana_ultima_hora} tope={linea.tope_hora} etiqueta="Campañas · última hora" />
    <Barra
      valor={linea.campana_ultimas_24h}
      tope={linea.tope_dia_hoy}
      etiqueta="Campañas · últimas 24 h"
      detalle={linea.calentando
        ? `Calentando la línea: hoy hasta ${linea.tope_dia_hoy}, sube cada día con envíos hasta ${linea.tope_dia_maximo}.`
        : null}
    />
    <Barra
      valor={linea.linea_salientes_hora}
      tope={linea.linea_para_campanas}
      etiqueta="Toda la línea · última hora"
      detalle={`Incluye la atención en vivo. El techo de la línea es ${linea.linea_tope_hora} por hora; el resto queda reservado para atender.`}
    />
  </div>
);
